// IE11 polyfills
import 'core-js' // ES6+
import 'intersection-observer'
import smoothscroll from 'smoothscroll-polyfill' // The behavior property of the ScrollToOptions dictionary specifies whether the scrolling should animate smoothly, or happen instantly in a single jump.

smoothscroll.polyfill()
